import { defineFetch } from 'resift';

const makeUpdateSource = defineFetch({
  displayName: 'Get Source',
  make: sourceId => ({
    request: data => ({ http }) =>
      http({
        method: 'PUT',
        route: `/sources/${sourceId}`,
        query: { expand: ['fields', 'authorizationStatus', 'groups'] },
        data,
      }),
  }),
});

export default makeUpdateSource;
